import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToIdle = (
    idle$: Observable<void>,
    frameStore: IFrameStore
): Subscription =>
    idle$
        .subscribe(() => setTimeout(frameStore.actions.idleControls()));

export default subscribeToIdle;